class CardsWithTextSwiper {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM and Swiper to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.waitForSwiper());
    } else {
      this.waitForSwiper();
    }
  }

  waitForSwiper() {
    // Check if Swiper is available, if not wait a bit
    if (typeof Swiper === 'undefined') {
      setTimeout(() => this.waitForSwiper(), 100);
      return;
    }
    
    // Initialize swipers immediately for cards-with-text
    this.initSwipers();
  }

  initSwipers() {
    const swiperContainers = document.querySelectorAll('.cards-with-text-swiper');
    
    if (swiperContainers.length === 0) {
      return;
    }
    
    swiperContainers.forEach((container) => {
      this.initializeSwiper(container);
    });
  }

  initializeSwiper(container) {
    const sectionId = container.dataset.sectionId;
    
    const slidesMobile = Math.max(1, Math.min(4, parseFloat(container.dataset.slidesMobile) || 1));
    const slidesTablet = Math.max(1, Math.min(4, parseFloat(container.dataset.slidesTablet) || 3));
    const slidesDesktop = Math.max(1, Math.min(4, parseFloat(container.dataset.slidesDesktop) || 3));
    
    const swiper = new Swiper(container, {
      slidesPerView: slidesMobile,
      spaceBetween: 20,
      loop: false,
      
      breakpoints: {
        768: {
          slidesPerView: slidesTablet,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: slidesDesktop,
          spaceBetween: 32,
        }
      },

      navigation: {
        nextEl: `[data-section-id="${sectionId}"] .swiper-next`,
        prevEl: `[data-section-id="${sectionId}"] .swiper-prev`,
      },

      pagination: {
        el: `[data-section-id="${sectionId}"] .swiper-pagination`,
        clickable: true,
        dynamicBullets: true,
      },

    });


    this.addArrowVisibilityHandler(container);
  }

  addArrowVisibilityHandler(container) {
    const arrows = container.querySelector('.swiper-arrow-wrapper');
    if (!arrows) return;

    const updateVisibility = () => {
      const windowWidth = window.innerWidth;
      if (windowWidth >= 1280) {
        arrows.style.display = 'none';
      } else {
        arrows.style.display = 'flex';
      }
    };

    updateVisibility();

    window.addEventListener('resize', updateVisibility);
  }
}

new CardsWithTextSwiper();

document.addEventListener('shopify:section:load', () => {
  new CardsWithTextSwiper();
});

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => new CardsWithTextSwiper(), 1000);
});